export const saturdayAbbreviatedLowercase = "jSvQ1";
export default {saturdayAbbreviatedLowercase};